<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="固结总计划：" prop="plan_gt1">
                <el-input v-model="model.plan_gt1" style="width: 200px"></el-input>（M）
            </el-form-item>
            <el-form-item label="帷幕总计划：" prop="plan_gt2">
                <el-input v-model="model.plan_gt2" style="width: 200px"></el-input>（M）
            </el-form-item>
            <el-form-item label="回填总计划" prop="plan_gt3">
                <el-input v-model="model.plan_gt3" style="width: 200px"></el-input>（m²）
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { getUserInfo, getModelById } from '@/api/common'
import { saveProjectPlan } from '@/api/projectdivision'

export default {
    name: 'projectPlan',
    mixins: [editutil],
    data() {
        return {
            model: {
                plan_gt1: '',
                plan_gt2: '',
                plan_gt3: ''
            },
            getObj:{
                url:'/api/admin/projectdivision/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {},
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    saveProjectPlan(this.model.plan_gt1, this.model.plan_gt2, this.model.plan_gt3).then(res=>{
                        if(res.code == 1){
                            this.$msgs("设置成功")
                            this.closeDialog()
                        }else{
                            this.$msg(res.msg)
                        }
                    })
                }
            })
        },
        getModelData() {
            let u_token = sessionStorage.getItem("U_TOKEN")
            if(u_token == null){
                u_token = ""
            }
            getUserInfo(u_token).then(res=>{
                if(res.code == 1){
                    this.getObj.data.value = res.data.org_pid;
                    getModelById(this.getObj).then(res => {
                        if (res.code === 1) {
                            this.model = res.data;
                        } else {
                            this.$msg(res.msg)
                            this.closeDialog()
                        }
                    })
                }
            })
            
        },
    }
};
</script>